<template>
  <div class="poppins" :class="{ 'sb-nav-fixed': !isLoginPage }">
    <Navbar v-if="!isLoginPage"></Navbar>
    <div :id="layoutId">
      <SideBar v-if="!isLoginPage"></SideBar>
      <div :id="contentId">
        <router-view></router-view>
        <Footer v-if="!isLoginPage"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import SideBar from "./components/SideBar.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Navbar,
    SideBar,
    Footer,
  },
  mounted() {
    // console.log(this.$route);
  },
  computed: {
    isLoginPage() {
      if (
        this.$route.matched.some((record) => record.meta.publicLayout) ||
        this.$route.path === "/" ||
        this.$route.path === "/login" ||
        this.$route.path === "/registrasi" ||
        this.$route.path === "/formulir-1-perbaikan-bangunan-irigasi" ||
        this.$route.path === "/formulir-2-perbaikan-saluran-irigasi" ||
        this.$route.path === "/formulir-3-jalan-inspeksi" ||
        this.$route.path === "/formulir-4-galian-endapan" ||
        this.$route.path === "/formulir-5-luas-tanam" ||
        this.$route.path === "/formulir-6-foto-video" ||
        this.$route.path === "/formulir-7-bangunan-rumah-jaga" ||
        this.$route.path === "/formulir-8-rencana-tanam" ||
        this.$route.path === "/cetak/" + this.$route.params.id
      ) {
        return true;
      } else {
        return false;
      }
    },
    layoutId() {
      return this.isLoginPage ? "layoutAuthentication" : "layoutSidenav";
    },
    contentId() {
      return this.isLoginPage
        ? "layoutAuthentication_content"
        : "layoutSidenav_content";
    },
  },
};
</script>
<style scoped>
body {
  min-height: calc(100vh - 200px);
}
.poppins {
  font-family: "Poppins", sans-serif;
}
.wa-float-container {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 9999;
  text-decoration: none;
  background-color: #25d366; /* Official WA Green */
  color: white;
  border-radius: 50px; /* Pill shape */
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  max-width: 60px; /* Keadaan tertutup */
  height: 60px;
}

.wa-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding: 0 14px;
  white-space: nowrap;
}

.wa-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
}

.wa-text {
  font-size: 0.9rem;
  font-weight: 600;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s ease;
  margin-right: 10px;
}

/* Efek Hover: Melebar dan menampilkan teks */
.wa-float-container:hover {
  max-width: 200px; /* Melebar saat di-hover */
  background-color: #128c7e; /* Darker WA Green */
  padding-left: 20px;
}

.wa-float-container:hover .wa-text {
  opacity: 1;
  transform: translateX(0);
}

/* Animasi Pulse Halus (Agar menarik perhatian tanpa mengganggu) */
@keyframes wa-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

.wa-float-container {
  animation: wa-pulse 2s infinite;
}

/* Bayangan Bayangan Modern */
.shadow-lg {
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
}

/* Penyesuaian Responsif untuk Mobile */
@media (max-width: 768px) {
  .wa-float-container {
    right: 20px;
    bottom: 20px;
    height: 50px;
    max-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wa-float-container:hover {
    max-width: 50px; /* Di mobile tidak perlu melebar saat disentuh */
    padding-right: 20px;
  }
  .wa-text {
    display: none;
  }
}
</style>
